import React from 'react';
import { TooltipHost, ITooltipHostProps } from 'office-ui-fabric-react/lib/Tooltip';

export interface TooltipWrapperProps extends ITooltipHostProps {}

export const TooltipWrapper = ({ children, ...tooltipProps }: React.PropsWithChildren<TooltipWrapperProps>) => {
    return <TooltipHost {...tooltipProps}>{children}</TooltipHost>;
};
